import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getData, API_ENABLED } from './lib/api';

const SUPPORTED = ['en', 'per', 'ps'];

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    // Options for language detector
    detection: {
      order: ['path', 'cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    react: {
      // Re-render components when a resource bundle is added at runtime, so
      // admin-edited text appears as soon as it arrives.
      bindI18nStore: 'added',
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
  });

/**
 * The bundled JSON files above are the baseline, so the site always has text
 * even with no backend. Anything an administrator edits in the admin panel is
 * then merged on top, which is why no rebuild is needed to change wording.
 */
const loadedFromApi = new Set();

async function mergeApiTranslations(language) {
  const locale = SUPPORTED.includes(language) ? language : 'en';

  if (!API_ENABLED || loadedFromApi.has(locale)) return;

  const strings = await getData(`/translations/${locale}`);

  if (strings && typeof strings === 'object' && Object.keys(strings).length > 0) {
    // deep: true, overwrite: true — admin text wins over the bundled text.
    i18next.addResourceBundle(locale, 'translation', strings, true, true);
    loadedFromApi.add(locale);
  }
}

i18next.on('initialized', () => mergeApiTranslations(i18next.language));
i18next.on('languageChanged', (language) => mergeApiTranslations(language));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
